import ch from '../../js/customMdParse/componentHelper'

export const getItemChildIds = (state, getters, rootState) => (itemId) => {
  if (rootState.auth.currentUser == null) return []
  // if (Object.keys(state.items).length === 0 && state.items.constructor === Object) return []
  if (itemId == null) {
    return rootState.auth.currentUser.rootItems
  }
  return state.items[itemId].children || []
}

export const getItemChildren = (state, getters, rootState) => (itemId) => {
  let children = []
  let childIds = getters.getItemChildIds(itemId)
  childIds.forEach(cid => {
    let c = state.items[cid]
    if (c == null) return
    children.push({
      id: cid,
      name: ch.getItemName(c)
    })
  })
  return children
}

export const getParents = (state, getters, rootState) => (itemId) => {
  let parents = []
  Object.keys(state.items).forEach((k) => {
    if (!('children' in state.items[k])) return
    if (state.items[k].children.indexOf(itemId) >= 0) parents.push(k)
  })

  if (rootState.auth.currentUser != null) {
    if (rootState.auth.currentUser.rootItems.indexOf(itemId)) parents.push(null)
  }

  return parents
}

export const getItemName = (state) => (itemId) => {
  return ch.getItemName(state.items[itemId])
}
